<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconUnlock_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.165 9.462V5.835c0-1.653 1.263-2.998 2.938-2.998s2.938 1.345 2.938 2.998v.725H22v-.725C22 3.166 19.806 1 17.103 1s-4.897 2.166-4.897 4.835v3.627z"
    />
    <path
        fill="currentColor"
        d="M2.98 9.462c-.542 0-.98.432-.98.967v11.604c0 .534.438.967.98.967h14.2c.541 0 .98-.433.98-.967V10.429a.973.973 0 0 0-.98-.967z"
    />
</svg>
